import { render, staticRenderFns } from "./NavListItem.vue?vue&type=template&id=4651f45e&"
import script from "./NavListItem.vue?vue&type=script&lang=ts&"
export * from "./NavListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports